import { Link } from 'react-router-dom';
import { PushSettings } from '../notifications/PushSettings';
import { DigestSettings } from '../todo/DigestSettings';
import { useMe } from './useMe';
import '../settings/settings.css';

/**
 * "Moje konto": the logged-in user's own settings — notifications on their devices, and the way to change the
 * password. Opened from the bell (⚙) and from "Powiadomienia"; the sidebar stays as it is (docs/wyglad.md).
 */
export function MyAccountPage() {
  const { me } = useMe();
  if (!me) return null;
  return (
    <section className="page narrow settings-page my-account">
      <h1>Moje konto</h1>
      <p className="muted">
        {me.name} · {me.email}
      </p>
      <PushSettings />
      <DigestSettings />
      <section className="settings-section" aria-labelledby="password-title">
        <h2 id="password-title">Hasło</h2>
        <p className="hint">
          <Link to="/haslo">Zmień hasło</Link> — inne urządzenia zostaną wylogowane.
        </p>
      </section>
    </section>
  );
}
